import { IconButton as MuiIconButton, Tooltip } from '@mui/material';
import React, { ReactNode, Ref } from 'react';
import trackingService, { TrackingEvent } from '../../../Services/Tracking/TrackingService';

interface IIconButtonProps {
    className?: string;
    handleClick?: ((event: React.MouseEvent<HTMLButtonElement>) => void) | (() => void);
    children: ReactNode;
    reference?: Ref<HTMLButtonElement>;
    value?: string;
    size?: 'small' | 'medium' | 'large';
    color?: 'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    tooltipPlacement?:
        | 'bottom-end'
        | 'bottom-start'
        | 'bottom'
        | 'left-end'
        | 'left-start'
        | 'left'
        | 'right-end'
        | 'right-start'
        | 'right'
        | 'top-end'
        | 'top-start'
        | 'top';
    tooltip?: string;
    disabled?: boolean;
    testId?: string | undefined;
    track: TrackingEvent;
}

const IconButton: React.FC<IIconButtonProps> = (props: IIconButtonProps) => {
    const handleClick = (event?: React.MouseEvent<HTMLButtonElement>) => {
        if (props.handleClick) {
            props.handleClick(event!);
        }
        trackingService.track(props.track);
    };

    return (
        <Tooltip title={props.tooltip} placement={props.tooltipPlacement ?? 'bottom-start'}>
            <span style={props.disabled ? { display: 'inline-block' } : undefined}>
                <MuiIconButton
                    className={props.className}
                    size={props.size}
                    color={props.color ?? 'primary'}
                    style={{ backgroundColor: 'transparent' }}
                    disableRipple
                    disableFocusRipple
                    ref={props.reference}
                    onClick={handleClick}
                    data-testid={props.testId}
                    value={props.value}
                    disabled={props.disabled}
                >
                    {props.children}
                </MuiIconButton>
            </span>
        </Tooltip>
    );
};

export default IconButton;
